import { IListFeesViewProps } from "../../interfaces/configuration";
import {
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { getListOfSelectedCarrierNames } from "../../utils/carriers";
import { FEE_RULES_DICT, MARKETPLACE } from "../../utils/constants";
import { getFeeString } from "../../utils/text";
import ListHeader from "./ListHeader";
import ListPagination from "./ListPagination";
import ConfirmationModal from "../modals/ConfirmationModal";

const ListFeesView = ({
  entity,
  fees,
  setSelectedFee,
  page,
  handlePageChange,
  count,
  carrierList,
  columns,
  getMerchantListFromArrayOfIds,
  handleOpenConfirmationModal,
  handleToggleFee,
  openConfirmationModal,
  handleCloseConfirmationModal,
  deleteFee,
}: IListFeesViewProps) => (
  <>
    <TableContainer component={Paper} className="m-t-40 br-20 bg-light">
      <Table>
        <ListHeader columns={columns} />
        <TableBody>
          {fees.map((fee) => {
            const {
              name,
              orderPrice,
              orderPriceType,
              deliveryPrice,
              deliveryPriceType,
              weight,
              weightType,
              merchants,
              carriers,
              fee: feeAmount,
              enabled,
            } = fee;
            return (
              <TableRow key={name}>
                <TableCell>{name}</TableCell>
                <TableCell>
                  {orderPrice && orderPrice > 0
                    ? `${FEE_RULES_DICT[orderPriceType]} ${getFeeString(
                      orderPrice
                    )}`
                    : "-"}
                </TableCell>
                <TableCell>
                  {deliveryPrice && deliveryPrice > 0
                    ? `${FEE_RULES_DICT[deliveryPriceType]} ${getFeeString(
                      deliveryPrice
                    )}`
                    : "-"}
                </TableCell>
                <TableCell>
                  {weight && weight > 0
                    ? `${FEE_RULES_DICT[weightType]} ${weight} kg`
                    : "-"}
                </TableCell>
                {entity === MARKETPLACE && (
                  <TableCell>
                    {Array.isArray(merchants) && merchants.length > 0
                      ? getMerchantListFromArrayOfIds(merchants)
                      : "Todos"}
                  </TableCell>
                )}
                <TableCell>
                  {Array.isArray(carriers) && carriers.length > 0
                    ? getListOfSelectedCarrierNames(carrierList, carriers)
                    : "Todos"}
                </TableCell>
                <TableCell>{getFeeString(feeAmount)}</TableCell>
                <TableCell>
                  <Typography
                    className={`f-s-14 ${
                      enabled ? "color-primary" : "text-muted"
                    }`}
                  >
                    {enabled ? "Activo" : "Inactivo"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Switch
                    size="small"
                    checked={enabled}
                    onChange={(e: any, checked: boolean) =>
                      handleToggleFee(fee.id, checked)
                    }
                  />
                  <IconButton onClick={() => setSelectedFee(fee)}>
                    <i className="material-symbols-rounded">edit</i>
                  </IconButton>
                  <IconButton
                    onClick={() => handleOpenConfirmationModal(fee.id)}
                  >
                    <i className="material-symbols-rounded">delete</i>
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <ListPagination
        total={count}
        page={page}
        onChangePage={handlePageChange}
      />
    </TableContainer>

    <ConfirmationModal
      text="¿Seguro que deseas eliminar esta regla?"
      open={openConfirmationModal}
      onClose={handleCloseConfirmationModal}
      onSubmit={deleteFee}
    />
  </>
);

export default ListFeesView;
